module.exports = __webpack_public_path__ + "static/media/logo.196c8f3a.png";